

export enum ProcedureStateType {
    Draft = 0,
    Review = 1,
    Published = 2,
    Suspended = 3,
    Inactive = 4
}

export let PROCEDURE_STATE = [
    ProcedureStateType.Draft,
    ProcedureStateType.Review,
    ProcedureStateType.Published,
    ProcedureStateType.Suspended,
    ProcedureStateType.Inactive
]